import { connect } from "react-redux";
import { fetch, create, update } from "../store/actions/categories";

import Form from '../components/categories/Form';
import withAuth from '../hocs/withAuth';

function mapStateToProps(state, ownProps) {
  return {
    errors: state.errors,
    user: state.currentUser.user,
    categories: state.categories
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAll: () => {
      return dispatch(fetch());
    },
    create: (data) => {
      return dispatch(create(data));
    },
    update: (data) => {
      return dispatch(update(data));

    }
  }
}
export const ManageCategories = withAuth(connect(mapStateToProps, mapDispatchToProps)(Form));



// WEBPACK FOOTER //
// ./src/containers/Categories.js